import React from 'react';
import Typography from '@mui/material/Typography';
import {
  Done, DoneAll, AccessTime,
  SmsFailed, People,
  Info
} from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import { green, grey, orange } from '@mui/material/colors';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import {
  data as smsStatus,
  NOT_SEND,
  SEND,
  FAILED,
  PENDING
} from '@lba-dev/package.local-globals/smsStatus';
import {
  WHATSUP,
  WHATSAPPBUSINESS
} from '@lba-dev/package.local-globals/smsMode';
import { List } from 'immutable';

const IconDisplay = ({ message, classes }) => {
  const status = smsStatus.find((e) => e._id === message.get('status'));
  let Icon = {
      [NOT_SEND]: SmsFailed,
      [SEND]: Done,
      [FAILED]: SmsFailed,
      [PENDING]: AccessTime,
    }[message.get('status') || NOT_SEND],
    color = status?.color[700],
    name = status?.name;
  const errorMessage = message.get('errorMessage');

  if ([WHATSAPPBUSINESS, WHATSUP].includes(message.get('mode'))) {
    if (message.get('status') === SEND) {
      Icon = DoneAll;
      color = grey[700];
      name = 'Reçu';
    } else if (message.get('status') === PENDING) {
      Icon = Done;
      color = grey[700];
      name = 'Envoyé';
    }
    if (message.get('dateRead')) {
      color = green[700];
      name = 'Vu';
    }
  }
  return Icon ? (
    <>
      <Tooltip disableInteractive title={`Status: ${name}`}>
        <Icon fontSize="small" className={classes.sendIcon} style={{ color }} />
      </Tooltip>
      {errorMessage && (
        <Tooltip disableInteractive title={errorMessage}>
          <Info
            fontSize="small"
            className={classes.sendIcon}
            style={{ color: orange[700] }}
          />
        </Tooltip>
      )}
    </>
  ) : '';
};


const MessageFooter = ({ classes, message }) => {
  const sender = message.get('sender');
  const date = new Date(message.get('date'));
  const dateEnvoi = new Date(message.get('dateEnvoi', date));
  const format = dayjs(date).isSame(dayjs(), 'day') ? 'HH:mm' :
    ((dayjs(date).isSame(dayjs(), 'year') && 'D MMM HH:mm') || 'LLL');
  const seenBy = message.get('seenBy', new List()).toJS();
  const displayDateEnvoi = dayjs(dateEnvoi).format(format);
  return <>
    {sender &&
    <div className={classes.done}>
      <Typography
        align="right"
        className={classes.senderName}
        variant="caption"
        noWrap
      >
        {displayDateEnvoi}
      </Typography>
    </div>
    }
    <div className={classes.done}>
      {sender && <IconDisplay message={message} classes={classes} />}
      {!sender &&
      seenBy.length ?
        <Tooltip title={seenBy.map(e => e.login).join(', ')}>
          <People fontSize='small' color='action' />
        </Tooltip> : ''}
    </div>
  </>;
};

export default MessageFooter;
